module.exports = __webpack_public_path__ + "Roboto-Medium.5b229d8ff0697253d0f0.woff";


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/assets/font/roboto/Roboto-Medium.woff
// module id = ../../../../../src/assets/font/roboto/Roboto-Medium.woff
// module chunks = 2